<template>
  <div class="employment">
    <toptitle :title1="titlework" />
    <p class="history">申请历史</p>
    <van-cell-group>
      <van-cell v-for="(item, index) in listArr"
                :key="index"
                :title="item.C_PROVE_TYPE == '10' ? '收入证明' : item.C_PROVE_TYPE == '20' ? '在职证明':'居住证明'"
                :value="item.EFFDT"
                @click="checkProve(item)" />
    </van-cell-group>
  </div>
</template>

<script>
import toptitle from '../toptitle'
import axios from 'axios'
import { proveHistoryDataApi } from '../../request/api'
import { Toast } from 'vant'
import _ from 'lodash'
export default {
  name: 'prorecord',
  data() {
    return {
      titlework: '证明记录',
      listArr: [],
    }
  },
  methods: {
    checkProve(item) {
      this.$router.push({ path: 'provement', query: item })
    },
  },
  components: {
    toptitle,
  },
  created() {
    //正式
    let prams = {
      //sessionStorage.getItem('EMPLID')
      EMPLID: sessionStorage.getItem('EMPLID'),
      // getpageNo: '1',
      // pageRecords: '10000',
      // roleType: 'emp',
    }
    proveHistoryDataApi(prams).then((res) => {
      if (res.CODE === 200) {
        this.listArr = res.DATA
      } else {
        Toast(res.MESSAGE)
      }
    })
    // axios
    //   .get('http://120.35.35.2:8050/emp/cert_list', {
    //     params: {
    //       emplid: sessionStorage.getItem('EMPLID'),
    //       getpageNo: '1',
    //       pageRecords: '10000',
    //       roleType: 'emp',
    //     },
    //   })
    //   .then((res) => {
    //     if (res.data.code == 200) {
    //       this.listArr = res.data.data
    //     }
    //   })
  },
}
</script>

<style lang="less" scoped>
.history {
  height: 44px;
  line-height: 44px;
  padding-left: 15px;
  background: #007fc6;
  color: #fff;
}
</style>
